import React from "react";

const BasketballMatchDetails = ({ matches, userNames, styles }) => {
  return matches.map((match, matchIndex) => (
    <div key={matchIndex} style={{ marginBottom: "clamp(18px, 4vw, 25px)" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "clamp(15px, 4vw, 20px)",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <h4
          style={{
            color: "#2c3e50",
            margin: 0,
            fontSize: "clamp(16px, 3.5vw, 20px)",
          }}
        >
          Match #{matchIndex + 1}
        </h4>
        <span
          style={{
            backgroundColor:
              match.winner === "user"
                ? "#27ae60"
                : match.winner === "opponent"
                ? "#e74c3c"
                : "#95a5a6",
            color: "white",
            padding: "clamp(3px, 1vw, 4px) clamp(10px, 2.5vw, 12px)",
            borderRadius: "20px",
            fontSize: "clamp(11px, 2.2vw, 12px)",
            fontWeight: "600",
          }}
        >
          {match.winner === "user"
            ? "WIN"
            : match.winner === "opponent"
            ? "LOSS"
            : "TIE"}
        </span>
      </div>

      {/* Team Names & Score */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#f8f9fa",
          padding: "clamp(15px, 4vw, 20px)",
          borderRadius: "12px",
          marginBottom: "clamp(15px, 4vw, 20px)",
          border: "2px solid #e9ecef",
          flexWrap: "wrap",
          gap: "15px",
        }}
      >
        <div style={{ textAlign: "center", flex: 1, minWidth: "120px" }}>
          <h3
            style={{
              color: "#2c3e50",
              margin: "0 0 clamp(8px, 2vw, 10px) 0",
              fontSize: "clamp(16px, 3.5vw, 20px)",
            }}
          >
            {match.userTeamName || "Your Team"}
          </h3>
          <div
            style={{
              fontSize: "clamp(28px, 7vw, 36px)",
              fontWeight: "bold",
              color: "#27ae60",
            }}
          >
            {match.totalUserPoints}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "clamp(18px, 4.5vw, 24px)",
            fontWeight: "bold",
            color: "#6c757d",
            minWidth: "60px",
            justifyContent: "center",
          }}
        >
          VS
        </div>
        <div style={{ textAlign: "center", flex: 1, minWidth: "120px" }}>
          <h3
            style={{
              color: "#2c3e50",
              margin: "0 0 clamp(8px, 2vw, 10px) 0",
              fontSize: "clamp(16px, 3.5vw, 20px)",
            }}
          >
            {match.opponentTeamName || "Opponent Team"}
          </h3>
          <div
            style={{
              fontSize: "clamp(28px, 7vw, 36px)",
              fontWeight: "bold",
              color: "#e74c3c",
            }}
          >
            {match.totalOpponentPoints}
          </div>
        </div>
      </div>

      {/* Quarters & Overtime Scores */}
      <div style={{ marginBottom: "clamp(15px, 4vw, 20px)" }}>
        <h4
          style={{
            color: "#2c3e50",
            marginBottom: "clamp(12px, 3vw, 15px)",
            fontSize: "clamp(15px, 3vw, 18px)",
          }}
        >
          🏀 Quarter by Quarter
        </h4>
        <table style={styles.setsTable}>
          <thead>
            <tr>
              <th style={styles.tableTh}>Period</th>
              <th style={styles.tableTh}>
                {match.userTeamName || "Your Team"}
              </th>
              <th style={styles.tableTh}>
                {match.opponentTeamName || "Opponent"}
              </th>
            </tr>
          </thead>
          <tbody>
            {match.quarters &&
              match.quarters.map((quarter, index) => (
                <tr key={index}>
                  <td style={styles.tableTd}>Q{index + 1}</td>
                  <td style={styles.tableTd}>{quarter.userTeamPoints}</td>
                  <td style={styles.tableTd}>{quarter.opponentTeamPoints}</td>
                </tr>
              ))}
            {match.overtimes &&
              match.overtimes.map((overtime, index) => (
                <tr key={`ot-${index}`}>
                  <td style={{ ...styles.tableTd, backgroundColor: "#fff3cd" }}>
                    OT{index + 1}
                  </td>
                  <td style={styles.tableTd}>{overtime.userTeamPoints}</td>
                  <td style={styles.tableTd}>{overtime.opponentTeamPoints}</td>
                </tr>
              ))}
            <tr style={{ backgroundColor: "#e9ecef", fontWeight: "bold" }}>
              <td style={styles.tableTd}>Total</td>
              <td style={styles.tableTd}>{match.totalUserPoints}</td>
              <td style={styles.tableTd}>{match.totalOpponentPoints}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Scoring Events */}
      {match.scoringEvents && match.scoringEvents.length > 0 && (
        <div style={{ marginBottom: "clamp(15px, 4vw, 20px)" }}>
          <h4
            style={{
              color: "#2c3e50",
              marginBottom: "clamp(12px, 3vw, 15px)",
              fontSize: "clamp(15px, 3vw, 18px)",
            }}
          >
            📊 Scoring Events
          </h4>
          <table style={styles.setsTable}>
            <thead>
              <tr>
                <th style={styles.tableTh}>Quarter</th>
                <th style={styles.tableTh}>Team</th>
                <th style={styles.tableTh}>Player</th>
                <th style={styles.tableTh}>Points</th>
                <th style={styles.tableTh}>Assist</th>
              </tr>
            </thead>
            <tbody>
              {match.scoringEvents.map((event, index) => (
                <tr key={index}>
                  <td style={styles.tableTd}>
                    {event.quarter <= 4
                      ? `Q${event.quarter}`
                      : `OT${event.quarter - 4}`}
                  </td>
                  <td style={styles.tableTd}>
                    {event.team === "user"
                      ? match.userTeamName
                      : match.opponentTeamName}
                  </td>
                  <td style={styles.tableTd}>{event.player}</td>
                  <td style={styles.tableTd}>
                    <span
                      style={{
                        backgroundColor:
                          event.points === 3
                            ? "#ffc107"
                            : event.points === 2
                            ? "#28a745"
                            : "#17a2b8",
                        color: "white",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        fontSize: "12px",
                      }}
                    >
                      {event.points}pt
                    </span>
                  </td>
                  <td style={styles.tableTd}>{event.assist || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Foul Events */}
      {match.foulEvents && match.foulEvents.length > 0 && (
        <div style={{ marginBottom: "clamp(15px, 4vw, 20px)" }}>
          <h4
            style={{
              color: "#2c3e50",
              marginBottom: "clamp(12px, 3vw, 15px)",
              fontSize: "clamp(15px, 3vw, 18px)",
            }}
          >
            ⚠️ Fouls
          </h4>
          <table style={styles.setsTable}>
            <thead>
              <tr>
                <th style={styles.tableTh}>Quarter</th>
                <th style={styles.tableTh}>Team</th>
                <th style={styles.tableTh}>Player</th>
                <th style={styles.tableTh}>Foul Type</th>
                <th style={styles.tableTh}>Time</th>
              </tr>
            </thead>
            <tbody>
              {match.foulEvents.map((foul, index) => (
                <tr key={index}>
                  <td style={styles.tableTd}>
                    {foul.quarter <= 4
                      ? `Q${foul.quarter}`
                      : `OT${foul.quarter - 4}`}
                  </td>
                  <td style={styles.tableTd}>
                    {foul.team === "user"
                      ? match.userTeamName
                      : match.opponentTeamName}
                  </td>
                  <td style={styles.tableTd}>{foul.player}</td>
                  <td style={styles.tableTd}>
                    <span
                      style={{
                        backgroundColor:
                          foul.foulType === "technical" ||
                          foul.foulType === "flagrant"
                            ? "#dc3545"
                            : "#6c757d",
                        color: "white",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        fontSize: "12px",
                      }}
                    >
                      {foul.foulType}
                    </span>
                  </td>
                  <td style={styles.tableTd}>{foul.time || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Team Rosters */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "clamp(12px, 4vw, 20px)",
        }}
      >
        <div>
          <h4
            style={{
              color: "#2c3e50",
              marginBottom: "clamp(8px, 2vw, 10px)",
              fontSize: "clamp(15px, 3vw, 18px)",
            }}
          >
            👥 {match.userTeamName || "Your Team"}
          </h4>
          <div
            style={{
              backgroundColor: "#f8f9fa",
              padding: "clamp(12px, 3vw, 15px)",
              borderRadius: "8px",
            }}
          >
            {match.userTeam && match.userTeam.length > 0 ? (
              match.userTeam.map((player, index) => {
                const playerName = player.userId
                  ? userNames[player.userId] || player.name
                  : player.name;
                return (
                  <div
                    key={index}
                    style={{
                      padding: "8px 0",
                      borderBottom: "1px solid #dee2e6",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>
                      <strong>#{player.number}</strong> {playerName}
                      {player.isCustom && (
                        <span
                          style={{
                            color: "#6c757d",
                            fontSize: "12px",
                            marginLeft: "5px",
                          }}
                        >
                          (Custom)
                        </span>
                      )}
                    </span>
                    <span style={{ fontSize: "12px", color: "#6c757d" }}>
                      {player.position}
                    </span>
                  </div>
                );
              })
            ) : (
              <div style={{ color: "#6c757d", fontStyle: "italic" }}>
                No players added
              </div>
            )}
          </div>
        </div>
        <div>
          <h4 style={{ color: "#2c3e50", marginBottom: "10px" }}>
            👥 {match.opponentTeamName || "Opponent Team"}
          </h4>
          <div
            style={{
              backgroundColor: "#f8f9fa",
              padding: "15px",
              borderRadius: "8px",
            }}
          >
            {match.opponentTeam && match.opponentTeam.length > 0 ? (
              match.opponentTeam.map((player, index) => {
                const playerName = player.userId
                  ? userNames[player.userId] || player.name
                  : player.name;
                return (
                  <div
                    key={index}
                    style={{
                      padding: "8px 0",
                      borderBottom: "1px solid #dee2e6",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>
                      <strong>#{player.number}</strong> {playerName}
                      {player.isCustom && (
                        <span
                          style={{
                            color: "#6c757d",
                            fontSize: "12px",
                            marginLeft: "5px",
                          }}
                        >
                          (Custom)
                        </span>
                      )}
                    </span>
                    <span style={{ fontSize: "12px", color: "#6c757d" }}>
                      {player.position}
                    </span>
                  </div>
                );
              })
            ) : (
              <div style={{ color: "#6c757d", fontStyle: "italic" }}>
                No players added
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Match Summary */}
      <div
        style={{
          backgroundColor: "white",
          padding: "clamp(15px, 4vw, 20px)",
          borderRadius: "8px",
          marginTop: "clamp(15px, 4vw, 20px)",
          boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
        }}
      >
        <h4
          style={{
            color: "#2c3e50",
            marginBottom: "clamp(12px, 3vw, 15px)",
            fontSize: "clamp(15px, 3vw, 18px)",
          }}
        >
          🏆 Match Summary
        </h4>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
            gap: "clamp(12px, 3vw, 15px)",
            fontSize: "clamp(12px, 2.5vw, 14px)",
          }}
        >
          <div>
            <strong>Winner:</strong>{" "}
            <span
              style={{
                color:
                  match.winner === "user"
                    ? "#27ae60"
                    : match.winner === "opponent"
                    ? "#e74c3c"
                    : "#6c757d",
                fontWeight: "bold",
              }}
            >
              {match.winner === "user"
                ? match.userTeamName || "Your Team"
                : match.winner === "opponent"
                ? match.opponentTeamName || "Opponent Team"
                : "Tie"}
            </span>
          </div>
          <div>
            <strong>Match Type:</strong> {match.matchType || "Regular"}
          </div>
          <div>
            <strong>Quarters Played:</strong>{" "}
            {4 + (match.overtimes?.length || 0)}
          </div>
          <div>
            <strong>Final Score:</strong> {match.totalUserPoints} -{" "}
            {match.totalOpponentPoints}
          </div>
          <div>
            <strong>Total Players:</strong>{" "}
            {(match.userTeam?.length || 0) + (match.opponentTeam?.length || 0)}
          </div>
        </div>
      </div>
    </div>
  ));
};

export default BasketballMatchDetails;
